import React from "react";
import { GobbyTableHeader } from "./gobby-table";

export function renderSortableHeader(
    label,
    field,
    sortField,
    sortDirection,
    handleSort,
) {
    return (
        <GobbyTableHeader
            className="cursor-pointer hover:bg-platinumlight transition-colors"
            onClick={() => handleSort(field)}
        >
            <div className="flex items-center gap-1">
                <span className="text-sm font-medium text-black-700">
                    {label}
                </span>
                <div>
                    {sortField === field ? (
                        sortDirection === "asc" ? (
                            <i className="material-icons text-black">
                                keyboard_arrow_up
                            </i>
                        ) : (
                            <i className="material-icons text-black">
                                keyboard_arrow_down
                            </i>
                        )
                    ) : (
                        <i className="material-icons text-blueblack">
                            keyboard_arrow_down
                        </i>
                    )}
                </div>
            </div>
        </GobbyTableHeader>
    );
}
